import { render } from "./NewInvoice.vue?vue&type=template&id=380a4a23&scoped=true"
import script from "./NewInvoice.vue?vue&type=script&lang=js"
export * from "./NewInvoice.vue?vue&type=script&lang=js"

import "./NewInvoice.vue?vue&type=style&index=0&id=380a4a23&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380a4a23"]])

export default __exports__